/**
 * @generated SignedSource<<cd0f3a35f8e1d77bf70f7b1fc82cb5cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProfileIconButtonGateQuery$variables = Record<PropertyKey, never>;
export type ProfileIconButtonGateQuery$data = {
  readonly me: {
    readonly id: string;
    readonly isHubAuth: boolean;
  };
};
export type ProfileIconButtonGateQuery = {
  response: ProfileIconButtonGateQuery$data;
  variables: ProfileIconButtonGateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Me",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isHubAuth",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileIconButtonGateQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileIconButtonGateQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "21053307ddc189a218c71c7d48799bde",
    "id": null,
    "metadata": {},
    "name": "ProfileIconButtonGateQuery",
    "operationKind": "query",
    "text": "query ProfileIconButtonGateQuery {\n  me {\n    id\n    isHubAuth\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d6dd41a98272a2599c6bfb8d3e99765";

export default node;
